export const GET_RULES = "GET_RULES";

export const ADD_RULE = "ADD_RULE";
export const EDIT_RULE = "EDIT_RULE";
// export const SET_SELECTED_RUID = "SET_SELECTED_RUID";